import type { StaffProfileData } from "services/api/company/staff.service";
import type {
  EmploymentDetailsForm,
  PersonalDetailsForm,
} from "./profilePanel.contract";
import { toLocalDateOrNull } from "./domains/employment/profilePanel.payload.logic";

export const EMPTY_PERSONAL_DETAILS: PersonalDetailsForm = {
  firstName: "",
  lastName: "",
  phoneNumber: "",
  email: "",
  personalIdentityNumber: "",
  teamIds: [],
};

export const EMPTY_EMPLOYMENT_DETAILS: EmploymentDetailsForm = {
  employmentType: "",
  role: "",
  employeeNumber: "",
  startDate: null,
  endDate: null,
  salary: "",
  salaryType: "",
  taxTable: "",
  paymentType: "",
  employeeCategory: "",
  workPercentage: "",
  agreement: "",
  noticeDays: "",
  vacationDays: "",
  workplace: "",
};

/**
 * Handles to personal details form.
 */
export const toPersonalDetailsForm = (
  profile: StaffProfileData | null,
): PersonalDetailsForm => {
  return {
    firstName: profile?.firstName ?? "",
    lastName: profile?.lastName ?? "",
    phoneNumber: profile?.phoneNumber ?? "",
    email: profile?.email ?? "",
    personalIdentityNumber: profile?.personalIdentityNumber ?? "",
    teamIds: profile?.workGroups.map((workGroup) => String(workGroup.id)) ?? [],
  };
};

/**
 * Handles to employment details form.
 */
export const toEmploymentDetailsForm = (
  profile: StaffProfileData | null,
): EmploymentDetailsForm => {
  const currentEmployment = profile?.employmentInfo?.current;
  const activeSalary =
    currentEmployment?.salaries?.find((salary) => salary.isActive) ?? null;
  const currentSalaryValue = activeSalary?.value ?? currentEmployment?.salary;

  return {
    employmentType: currentEmployment?.employmentType ?? "",
    role: currentEmployment?.role ?? "",
    employeeNumber: String(currentEmployment?.employeeNumber),
    startDate: toLocalDateOrNull(currentEmployment?.startDate),
    endDate: toLocalDateOrNull(currentEmployment?.endDate),
    salary: currentSalaryValue == null ? "" : String(currentSalaryValue),
    salaryType: currentEmployment?.salaryType ?? "",
    taxTable:
      currentEmployment?.taxTable == null
        ? ""
        : String(currentEmployment.taxTable),
    paymentType: currentEmployment?.paymentType ?? "",
    employeeCategory: currentEmployment?.employeeCategory ?? "",
    workPercentage:
      profile?.workPercentage == null
        ? ""
        : String(Math.round(profile.workPercentage * 100)),
    agreement: currentEmployment?.agreement ?? "",
    noticeDays:
      currentEmployment?.noticeDays == null
        ? ""
        : String(currentEmployment.noticeDays),
    vacationDays:
      currentEmployment?.vacationDays == null
        ? ""
        : String(currentEmployment.vacationDays),
    workplace: currentEmployment?.workplace ?? "",
  };
};
